import { createReducer } from '@reduxjs/toolkit';
import {
  storeEventTypeAction,
  storeLocationAction,
  storePeopleNumberAction,
} from './SearchActionCreator';

export interface SearchReducerState {
  location: string;
  eventType: string;
  lat: string;
  lng: string;
  peopleNumber: string;
}

export const initialState: SearchReducerState = {
  location: '',
  lat: '',
  lng: '',
  eventType: '',
  peopleNumber: '',
};

export const searchReducer = createReducer(initialState, (builder) => {
  builder.addCase(storeEventTypeAction, (state, action) => {
    state.eventType = action.payload;
  });
  builder.addCase(storeLocationAction, (state, action) => {
    state.location = action.payload.location;
    state.lat = action.payload.lat;
    state.lng = action.payload.lng;
  });
  builder.addCase(storePeopleNumberAction, (state, action) => {
    state.peopleNumber = action.payload;
  });
});
